import Settings from "../components/settings"

const SettingsPage = () => {
    return (<Settings/>)
}

export default SettingsPage